// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__W7dNL","large":"styles_large__2osbL"};